import React, { useState } from "react";
import GenericInput from "../../ui-components/Input/GenericInput";

const InputPlayground = ({ theme }: { theme: "light" | "dark" }) => {
  const [inputValue, setInputValue] = useState("");
  const [helperText, setHelperText] = useState("");
  const [hasError, setHasError] = useState(false);

  const validateInput = (value: string) => {
    if (!value) {
      setHelperText("This field is required.");
      setHasError(true);
    } else if (!/^[a-zA-Z0-9]*$/.test(value)) {
      setHelperText("The value must contain only letters and numbers.");
      setHasError(true);
    } else {
      setHelperText("This is the helper text.");
      setHasError(false);
    }
  };

  return (
    <section id="input" className="mb-10">
      <h2 className="text-2xl font-semibold mb-4">Input</h2>
      <GenericInput
        label="Search"
        value={inputValue}
        onChange={(value: string) => {
          setInputValue(value);
          validateInput(value);
        }}
        theme={theme}
        type="search"
        required
        helperText={helperText}
        hasError={hasError}
        tooltipText="Enter only alphanumeric characters."
      />
    </section>
  );
};

export default InputPlayground;
